import { Result, Button } from 'antd'
import { useNavigate } from 'react-router-dom'
import Colors from '../utils/colors'

const NotFound = () => {
  const navigate = useNavigate()

  return (
    <div style={{ height: 300, marginTop: 70, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <Result
        status="404"
        title="404"
        subTitle="Sorry, the page you visited does not exist."
        extra={
          <Button 
            type="primary" 
            onClick={() => navigate('/')}
            style={{
              backgroundColor: Colors.primary,
              borderColor: Colors.primary
            }}
          >
            Back Home
          </Button>
        }
      />
    </div>
  )
}

export default NotFound